<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('energyMonitor.cost.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('energyMonitor.cost.text.02')}}
              </v-col>
            </v-row>


            <v-row>
              <v-col class="text-justify">
                <strong>{{ $t('energyMonitor.cost.text.02')}}</strong><br>
                {{ $t('energyMonitor.cost.text.03')}}<br><br>
                <v-btn
                  text
                  color="primary"
                  style="margin-left:-12px"
                  @click="openQuestioner()">
                  {{ $t('common.questionnaire') }}
                </v-btn>
              </v-col>
            </v-row>

          </v-col>
        </v-row>

      </v-col>


    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'SubMeteringCost',
    extends: DataComponentBase,

    data: () => ({
    }),

    computed: {
    },
    methods: {
      openQuestioner() {
        let url = "https://docs.google.com/forms/d/e/1FAIpQLSd1sy6EwYUExCqsEhhuCpBh25hXLL-YQxC7riSs9bbXc_Sbkg/viewform?embedded=true";
        window.open(url,'_blank');
      },
    },
  }
</script>
